import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { useAtomValue } from 'jotai';
import { Link } from 'react-router';
import { RoutePaths } from '../routes/AppRoutes';
import { PageWrapper } from '../common/components/PageWrapper';
import { currentContextAtom } from '../state';
import TopAppBar from '../common/components/TopAppBar';
import CompanyProductSearch from './CompanyProductSearch';
import MyCompanyInfoCard from './MyCompanyInfoCard';
import { canEditCompanySettingsAtom } from './state';

export default function MyCompanyPage(): React.JSX.Element {
  const { t } = useTranslation(['common']);
  const { companyId } = useAtomValue(currentContextAtom);
  const canEdit = useAtomValue(canEditCompanySettingsAtom);

  return (
    <>
      <TopAppBar
        configuration="small"
        backTo={canEdit ? RoutePaths.COMPANY_PROFILE : RoutePaths.ROOT}
        shouldCheckHistory={!canEdit}
        title={t('settings:company')}
      />
      <PageWrapper
        sx={{
          pt: { xs: 0.5, lg: 3 },
        }}
      >
        <MyCompanyInfoCard canEdit={canEdit} />
        <Box
          sx={{
            p: { xs: 0, lg: 2 },
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: 1,
              alignItems: { xs: 'start', lg: 'center' },
              flexDirection: {
                xs: 'column',
                sm: 'row',
              },
            }}
          >
            <Typography variant="titleLarge">
              {t('common:product_other')}
            </Typography>
            {canEdit && (
              <Button
                variant="tonal"
                component={Link}
                to={RoutePaths.COMPANY_PRODUCTS}
                startIcon={<EditIcon />}
              >
                {t('settings:update_my_products')}
              </Button>
            )}
          </Box>

          <Box>
            <CompanyProductSearch contextCompanyId={companyId} companyId={companyId} />
          </Box>
        </Box>
      </PageWrapper>
    </>
  );
}
